import { RowConfig } from "../../pages/organizationChart/pages/generalConfig/utils/types";
import { Http } from "../../utils/types";
import { Format } from "../../utils/types/generals";
import { ConfigListPayload, CreateConfigPayload, DeleteConfigPayload, GetConfigPayload, UpdateConfigPayload } from "./body";
import { formatConfig } from "./format";
import { ConfigByID, CreateConfig, getConfig } from "./response";

export const serviceAreaDepartment = (client: Http) => ({
    config: async ({ query }: ConfigListPayload): Format<getConfig, RowConfig[]> => {
        const response = await client.get<getConfig>(`request/config/detailed${query ? '?' + query : ''}`)
        return formatConfig({ response })
    },
    createConfig: async ({ body }: CreateConfigPayload): Promise<CreateConfig> => await client.post<CreateConfig>('request/config', body),
    updateConfig: async ({ body, id }: UpdateConfigPayload): Promise<CreateConfig> => await client.put<CreateConfig>(`request/config/${id}`, body),
    getConfigById: async ({ id }: GetConfigPayload): Promise<ConfigByID> => await client.get<ConfigByID>(`request/config/${id}`),
    deleteConfig: async ({ id }: DeleteConfigPayload): Promise<CreateConfig> => await client.delete<CreateConfig>(`request/config/${id}`),
})